/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesLink, propTypesTextHtml } from '../../../constants/Proptypes';

const propTypesSliceHeaderHomepage = {
  header_title: PropTypes.shape(propTypesTextHtml),
  header_title_with_dynamic_text: PropTypes.shape(propTypesTextHtml),
  header_subtitle: PropTypes.string,
  header_dynamic_text: PropTypes.string,
  header_cta_subtitle: PropTypes.string,
};

const propTypesItemsHeaderHomepage = {
  header_cta_label: PropTypes.string,
  header_cta_link: PropTypes.shape(propTypesLink),
  header_cta_datatrack: PropTypes.string,
};

export const propTypesDataHeaderHomepage = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceHeaderHomepage),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsHeaderHomepage)),
};
